import { Component } from '@angular/core';

@Component({
  selector: 'app-notifications',
  standalone: false,
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})
export class NotificationsComponent {


  toggleCustomizer(event) {
    const element = document.getElementById('customizer');
    // console.log(element.classList);
    // element.classList.add('hll');
    // console.log(element.classList);
    if (element && element.classList.contains('open')) {
      element.classList.remove('open');
    } else {
      element.classList.add('open');
    }
  }
}
